import React from 'react'
import Projects from './Projects'; 
import Ecommence from './Ecommence';
import SchoolProjects from './SchoolProjects';
const ProjectHolder = () => {
    return (
        <>
        <Ecommence/> 
        <Projects/> 
        <SchoolProjects/> 
</> 
    )
}

export default ProjectHolder
